// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1JtQo","savePackageButton":"ClientWallet_savePackageButton__HSoHv"};